import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import type { Permission } from '@oficina/shared';
import { useAuth } from '@/hooks/use-auth';
import { EmptyState } from '@/components/common/states';

export function FullScreenLoader() {
  return (
    <div className="grid min-h-dvh place-items-center" aria-busy="true">
      <Loader2 className="h-6 w-6 animate-spin text-primary" aria-label="Carregando" />
    </div>
  );
}

/** Exige login; guarda a rota de origem para voltar depois de entrar. */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { user, isLoading } = useAuth();
  const location = useLocation();
  if (isLoading) return <FullScreenLoader />;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  return <>{children}</>;
}

export function RequirePermission({ permission, children }: { permission: Permission; children: ReactNode }) {
  const { can } = useAuth();
  if (!can(permission)) {
    return <EmptyState title="Acesso restrito" description="Seu perfil não tem permissão para acessar esta página." />;
  }
  return <>{children}</>;
}
